export default "__VITE_ASSET__Bnd5cObG__"